import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { Snackbar } from '@mui';

const ErrorSnackbar = () => {
  const errors = useSelector(state => state.errors);
  const previousLength = useRef(errors.length);

  useEffect(() => {
    if (errors.length > previousLength.current) {
      Snackbar.error({ message: R.propOr('', 'message', R.last(errors)), autoHideDuration: 5000 });
    }
    previousLength.current = errors.length;
  }, [errors]);

  return null;
};

export default ErrorSnackbar;
